import { render, staticRenderFns } from "./FmSplitDemo.vue?vue&type=template&id=1be260da&"
import script from "./FmSplitDemo.vue?vue&type=script&lang=js&"
export * from "./FmSplitDemo.vue?vue&type=script&lang=js&"
import style0 from "./FmSplitDemo.vue?vue&type=style&index=0&id=1be260da&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports